import React, { FC } from 'react';
import { SidebarDrawerIconProps } from './SidebarDrawerIconProps';
import ArrowBackIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIcon from '@mui/icons-material/ArrowForwardIos';
import { IconButton } from '@mui/material';
import { getLeftForIcon } from './utils';

const SidebarDrawerIcon: FC<SidebarDrawerIconProps> = ({
  clickHandler,
  drawerOpen,
}) => {
  const left = getLeftForIcon();
  return (
    <IconButton
      sx={{
        position: 'fixed',
        bottom: '30px',
        left: drawerOpen ? left : '25px',
        zIndex: 5000,
      }}
      onClick={() => clickHandler(!drawerOpen)}
    >
      {drawerOpen ? <ArrowBackIcon /> : <ArrowForwardIcon />}
    </IconButton>
  );
};

export default SidebarDrawerIcon;
